import React, { FC, ReactNode, useRef } from 'react';
import { AuthContext } from '@ryanar/react-auth-provider';
import { useTheme, useMediaQuery } from '@material-ui/core';
import { Scrollbars } from 'react-custom-scrollbars';
import useIntersectionRatio from 'utils/useIntersectionRatio';
import HeaderMenu from '../AuthScreenWrapper/parts/HeaderMenu';
import MenuWrapper from '../MenuWrapper/MenuWrapper';

import styles from './SupportWrapper.module.css';
import logo from 'assets/icons/sidemenus-PNG/FABLOGO.png';

interface ISupportWrapperProps {
  children: ReactNode
}

const SupportWrapper: FC<ISupportWrapperProps> = ({ children }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  // this hook triggers re-render when children content height gets changed, so the scrollbar may adapt
  useIntersectionRatio(contentRef);

  const theme = useTheme();
  const upLg1 = useMediaQuery(theme.breakpoints.up('lg1'));

  const { authenticated } = React.useContext(AuthContext);

  if (authenticated) {
    return <MenuWrapper>{children}</MenuWrapper>;
  }

  const getTrackVertical = (props) => <div {...props} className={styles.trackVertical} />;
  const getThumbVertical = (props) => <div {...props} className={styles.thumbVertical} />;

  return (
    <Scrollbars
      renderTrackVertical={getTrackVertical}
      renderThumbVertical={getThumbVertical}
      className={styles.background}
    >
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <img src={logo} alt="fab logo" />
        </div>
        <div className={styles.contentContainer}>
          {!upLg1 && <HeaderMenu />}
          <div className={styles.contentWrapper} ref={contentRef}>
            {children}
          </div>
        </div>
      </div>
    </Scrollbars>
  );
};

export default SupportWrapper;
